/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { DataSet } from "vis-data";

export const FORM_DATA = "@vlinder:mintpad-created-asset-formData";



export const formDataDs = new DataSet({
    fieldId: "id",
   
})


export const useFormDataDs = (data: any) => {
    console.log(`useFormDatads :`, data)

        formDataDs.update(data);
  

}